module.exports = __webpack_public_path__ + "img/10_bonus@3x.787c26fc.png";